const ErrorScreen = () => {
  return <div>AN ERROR OCCURRED. WE ARE WORKING ON IT...</div>;
};

export default ErrorScreen;
